import { DeleteOutlined, EditOutlined, PrinterOutlined } from '@ant-design/icons';
import { EmailButton } from '@components';
import { Inspection } from '@services';
import { Button, Col, Popconfirm, Row, Tooltip } from 'antd';

interface IProps {
  handleEdit: (id: string) => void;
  handlePublish: (id: string) => void;
  handleVhcEmailOpen: (id: string) => void;
  handlePrint: (id: string) => void;
  /** Takes the inspection off the job by category. Left out where the table is read-only. */
  handleRemove?: (categoryId: number) => void;
}

export const Columns = ({
  handleEdit,
  handlePublish,
  handleVhcEmailOpen,
  handlePrint,
  handleRemove,
}: IProps) => [
  // No titles: with one name and one row of buttons per line the headers said nothing, on the
  // desktop table or as labels on the mobile cards. The header row itself is hidden in CSS.
  {
    key: 'name',
    ellipsis: true,
    render: (inspection: Inspection) => inspection.category.name,
  },
  {
    key: 'action',
    align: 'right',
    render: (inspection: Inspection) => (
      <Row gutter={8} justify="end">
        <Col>
          <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(inspection.id)}>
            Edit
          </Button>
        </Col>
        <Col>
          <Popconfirm
            title="Are you sure?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => handlePublish(inspection.id)}
            disabled={inspection.isPublished}
          >
            <Button size="small" type="primary" disabled={inspection.isPublished}>
              {inspection.isPublished ? 'Published' : 'Publish'}
            </Button>
          </Popconfirm>
        </Col>
        <Col>
          <EmailButton size="small" onClick={() => handleVhcEmailOpen(inspection.id)} />
        </Col>
        <Col>
          <Button
            size="small"
            type="primary"
            icon={<PrinterOutlined />}
            onClick={() => handlePrint(inspection.id)}
          >
            Print
          </Button>
        </Col>
        {handleRemove && (
          <Col>
            {/* Published means the customer has it and a request was raised from it - that is not
                undone by taking the row off the job, so it stays. */}
            <Popconfirm
              title="Remove this inspection from the job?"
              okText="Remove"
              okButtonProps={{ danger: true }}
              cancelText="Keep"
              onConfirm={() => handleRemove(inspection.category.id)}
              disabled={inspection.isPublished}
            >
              {/* Tooltip directly on the button: a disabled button fires no mouse events, and only
                  Tooltip knows to wrap it so the hint still shows. */}
              <Tooltip
                title={
                  inspection.isPublished ? 'A published inspection cannot be removed' : undefined
                }
              >
                <Button
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  disabled={inspection.isPublished}
                >
                  Remove
                </Button>
              </Tooltip>
            </Popconfirm>
          </Col>
        )}
      </Row>
    ),
  },
];
